import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'previous_denial'
const storeType = 'previousDenials'

export const PEPreviousDenialsCardActions = {
  initPePreviousDenialsCard: ({ commit }, index) => {
    commit('setPePreviousDenialsCardLock', { index, lock: true })
  },
  peFetchPreviousDenialsCards: async ({ commit, getters }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  pePreviousDenialsCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            previous_application_filed: section.previous_application_filed,
            granted: section.granted,
            denied_by_uscis: section.denied_by_uscis,
            denied_by_immigration_judge: section.denied_by_immigration_judge,
            denied_by_bia: section.denied_by_bia,
            denied_by_unknown: section.denied_by_unknown,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPePreviousDenialsCardLock', { index: 'new', lock: true })
        commit('setPePreviousDenialsCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  pePreviousDenialsCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPePreviousDenialsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  pePreviousDenialsCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            previous_application_filed: section.previous_application_filed,
            granted: section.granted,
            denied_by_uscis: section.denied_by_uscis,
            denied_by_immigration_judge: section.denied_by_immigration_judge,
            denied_by_bia: section.denied_by_bia,
            denied_by_unknown: section.denied_by_unknown,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPePreviousDenialsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  pePreviousDenialsCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPePreviousDenialsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  pePreviousDenialsCardAddSection: ({ commit }) => {
    commit('setPePreviousDenialsCardLock', { index: 'new', lock: false })
    commit('addPePreviousDenialsCardSection', {
      id: null,
      previous_application_filed: false,
      granted: false,
      denied_by_uscis: false,
      denied_by_immigration_judge: false,
      denied_by_bia: false,
      denied_by_unknown: false,
      narrative: '',
    })
  },
  pePreviousDenialsCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PEPreviousDenialsCardMutations = {
  setPePreviousDenialsCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.PreviousDenialsCard) {
      Vue.set(state.partyEdit.partySections, 'PreviousDenialsCard', {})
    }
    Vue.set(state.partyEdit.partySections.PreviousDenialsCard, index, lock)
  },
  addPePreviousDenialsCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  pePreviousDenialsCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.PreviousDenialsCard, 'new', true)
  },
}

export const PEPreviousDenialsCardGetters = {
  pePreviousDenialsCardLock: state => index => state.partyEdit.partySections.PreviousDenialsCard[index],
  pePreviousDenialsCardHasNewSection: state => !!state.
    partyEdit.
    asylumAssystant[storeType]?.
    find(previousDenial => previousDenial.id === null),
}
